import axios from "axios";
import config from "../../config";
import { imprimir, imprimirDoc } from "../../helper/util";

const BASE_API = config.BASE_API;
const ENDERECO_API = config.ENDERECO_API;

const obterCPF = (cpf, antecipar = false) => {
  return axios.get(
    `${BASE_API}recadastramento/segurado/${cpf}?antecipar=${antecipar}`
  );
};

const obterRepresentante = (cpf) => {
  return axios.get(BASE_API + "recadastramento/representante/" + cpf);
};

const retificar = (id) => {
  return axios.get(BASE_API + "recadastramento/censo/" + id);
};

/*const getEndereco = (cep, if404Endereco) => {
  return axios
    .get(ENDERECO_API + "enderecos/" + cep)
    .then((response) => response.data)
    .catch(if404Endereco);
};*/

const getEndereco = (cep, if404Endereco) => {
  return axios
    .get(ENDERECO_API + "enderecos/" + cep)
    .then((response) => response.data)
    .catch((error) => {
      if (if404Endereco) {
        if404Endereco(error);
      }
      return Promise.reject(error);
    });
};

const finalizar = (params) => {
  return axios.post(BASE_API + "recadastramento", params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const visualizar = (idCenso) => {
  return axios
    .get(BASE_API + "recadastramento/comprovante/" + idCenso, {
      responseType: "blob",
    })
    .then((resp) => (resp ? resp.data : resp))
    .then((data) => {
      imprimir(data);
    });
};

const obterUF = (sigla) => {
  return axios.get(ENDERECO_API + "ufs/" + sigla);
};

const obterCidades = (uf) => {
  return axios.get(ENDERECO_API + "municipios", {
    params: {
      uf: uf,
      order: "ASC",
      size: 3000,
    },
  });
};

/*const obterCidades = (uf) => {
  return axios.get(ENDERECO_API + "municipios?uf=" + uf);
};*/

const obterPais = () => {
  return axios.get(BASE_API + "recadastramento/paises");
};

const obterHistorico = (cpf) => {
  return axios.get(BASE_API + "recadastramento/historico/" + cpf);
};

/*const obterBairros = (cidade) => {
  return axios.get(ENDERECO_API + "bairros?municipio_id=" + cidade);
};*/

const obterBairros = (cidade) => {
  return axios.get(ENDERECO_API + "bairros", {
    params: {
      municipio_id: cidade,
      order: "ASC",
    },
  });
};

const obterBairrosBancoGprev = (nomeCidade) => {
  return axios.get(`${BASE_API}util/bairros/${nomeCidade}`);
};

const getOpcoes = () => axios.get(BASE_API + "opcoes");

const getParametros = () => axios.get(`${BASE_API}recadastramento/parametros`);

const getArquivo = (token) =>
  axios.get(`${BASE_API}recadastramento/arquivo/${token}`);

/*const checkandoArquivoUpload = (fileList) => {
  return (
    Array.isArray(fileList) && fileList?.length > 0 && fileList[0].uid !== "-1"
  );
};*/

/*const mapCertidao = (valores, values, existeBeneficioPensao) => {
  return existeBeneficioPensao
    ? {
        certidao: {
          ...valores.certidao,
          ...values.certidao,
        },
      }
    : {};
};*/

const mapPessoa = (valores, attr) => {
  if (attr.endereco.bairro.nome) {
    attr.endereco.bairro = attr.endereco.bairro.nome;
  }

  return {
    pessoa: {
      ...valores.pessoa,
      ...attr.pessoa,
      ...attr.endereco,
      ...attr.contato,
    },
  };
};

/*const mapEndereco = (attr) => {
  return {
    endereco: {
      bairro: { nome: attr.bairro },
      cep: attr.cep,
      cidade: attr.cidade,
      complemento: attr.complemento,
      logradouro: attr.logradouro,
      pais: attr.pais,
      uf: attr.uf,
    },
  };
};

const mapRepresentanteLegal = (representanteLegal, tokenDocumento) => {
  return representanteLegal
    ? {
        representanteLegal: {
          ...representanteLegal,
          tokenDocumento,
        },
      }
    : {};
};*/

const formatarRequisicao = (
  valores,
  { pessoa, endereco, contato, dataReferenciaTela, ...values }
) => {
  var data = new FormData();
  valores.pessoaBanco = {
    ...values.pessoaBanco,
    id: valores.pessoaBanco?.id,
    versaoDoObjeto: valores.pessoaBanco?.versaoDoObjeto,
    poder: valores.pessoaBanco?.poder,
  };

  valores.documentoApresentado = { ...values.documentoApresentado };

  data.append("pessoaBanco", JSON.stringify(valores.pessoaBanco));
  data.append("arquivoDocumentos", valores.arquivoDocumentos);

  data.append("arquivoCertidao", valores.arquivoCertidao);

  data.append("imagemDaFoto", valores.imagemDaFoto);

  data.append("dataReferenciaTela", valores.dataReferenciaTela);
  

  /*const enderecoFormatado = {
    ...endereco,
    correspondencia: endereco?.correspondencia ? 1 : 0,
  };*/

  data.append(
    "censo",
    new Blob(
      [
        JSON.stringify({
          ...valores,
          ...mapPessoa(valores, { pessoa, endereco, contato }),
          endereco,
          contato,
        }),
      ],
      {
        type: "application/json",
      }
    )
  );
  return Promise.resolve(data);
};

const getComprovante = (idCenso) =>
  axios.get(`${BASE_API}comprovante/${idCenso}`);

const getDeclaResponbilidade = (params) => {
  return axios
    .get(BASE_API + "relatorios/termo-responsabilidade", {
      params,
      responseType: "blob",
    })
    .then((resp) => (resp ? resp.data : resp))
    .then((data) => {
      imprimirDoc(data, "DeclaracaoResponsabilidade");
    });
};

const listaDocumentoApresentacaoCenso = () => {
  return axios.get(`${BASE_API}util/documentoApresentado-censo`);
};

const salvarCarteiraTrabalho = (params) => {
  return axios.post(
    BASE_API + "util/carteira-trabalho",
    params
  );
};

const excluirCarteiraTrabalho = (id) => {
  return axios.delete(
    BASE_API + `util/carteira-trabalho/${id}`
  );
};

export default {
  obterCPF,
  obterUF,
  obterCidades,
  obterPais,
  obterBairros,
  getEndereco,
  finalizar,
  obterRepresentante,
  obterHistorico,
  visualizar,
  retificar,
  getOpcoes,
  getParametros,
  getArquivo,
  formatarRequisicao,
  getComprovante,
  getDeclaResponbilidade,
  listaDocumentoApresentacaoCenso,
  obterBairrosBancoGprev,
  salvarCarteiraTrabalho,
  excluirCarteiraTrabalho,
};
